import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import DeliveryPlanSearch from "@/components/DailyReportEdit/Combine/DeliveryPlanSearch.vue";
import DeliveryPlanList from "@/components/DailyReportEdit/Combine/DeliveryPlanList.vue";
import getDailyReportResponse from "@/types/responses/getDailyReport";
import getDailyReportRequest from "@/types/requests/getDailyReport";
import { ref, reactive, computed, onMounted } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import { formatDate } from "@/services/functions";
import DeliveryPlan from "@/types/DeliveryPlan";

const INITIAL_RANGE_DAYS = 3;

export default /*@__PURE__*/_defineComponent({
  __name: 'LeftPane',
  props: {
    modelValue: {},
    deliveryPlan: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const deliveryPlans = ref<DeliveryPlan[]>([]);
const totalPage = ref<number>(0);
const page = ref<number>(1);
const isSearching = ref<boolean>(false);

const props = __props;

function getInitialDateRange(leavingDateTime: string): Date[] {
  const startDate = new Date(leavingDateTime);
  const endDate = new Date(leavingDateTime);
  startDate.setDate(startDate.getDate() - INITIAL_RANGE_DAYS);
  endDate.setDate(endDate.getDate() + INITIAL_RANGE_DAYS);

  return [startDate, endDate];
}

let searchParams = reactive({
  operation_office_id: props.deliveryPlan.driver.officeable_id,
  driver_id: props.deliveryPlan.driver_id,
  account_id: props.deliveryPlan.driver.id,
  daterange: getInitialDateRange(props.deliveryPlan.leaving_warehouse_date_time),
  selectDateType: 'leaving',
})

onMounted(() => {
  getDeliveryPlans(makeInitialParams());
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

function getDeliveryPlans(req: getDailyReportRequest) {
  isSearching.value = true;
  Api().getDailyReports(req).then((data: getDailyReportResponse) => {
    deliveryPlans.value = data.items;
    totalPage.value = data.total_page;
    page.value = data.current_page;
  }).finally(() => {
    isSearching.value = false;
  });
}

function makeInitialParams(): getDailyReportRequest {
  searchParams.selectDateType
  return {
    operation_office_id: searchParams.operation_office_id,
    driver_id: searchParams.driver_id,
    account_id: searchParams.account_id,
    daterange: convertDateTimeToDate(searchParams.daterange[0]) + " - " + convertDateTimeToDate(searchParams.daterange[1]),
    delivery_date: 1,
    return_date: 0,
    page: page.value
  }
}

function makeParams(): getDailyReportRequest {
  return {
    operation_office_id: searchParams.operation_office_id,
    driver_id: searchParams.driver_id,
    account_id: searchParams.account_id,
    daterange: convertDateTimeToDate(searchParams.daterange[0]) + " - " + convertDateTimeToDate(searchParams.daterange[1]),
    delivery_date: searchParams.selectDateType === 'leaving' ? 1 : 0,
    return_date: searchParams.selectDateType === 'returning' ? 1 : 0,
    page: page.value
  }
}

function convertDateTimeToDate(datetime: Date | undefined): string {
  if (!datetime) {
    return ''
  }
  return formatDate(datetime, '/')
}

function updatePage(newPage: number) {
  page.value = newPage;
  getDeliveryPlans(makeParams());
}


return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "w-100" }, {
    default: _withCtx(() => [
      _createVNode(DeliveryPlanSearch, {
        deliveryPlan: props.deliveryPlan,
        modelValue: _unref(searchParams),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchParams) ? (searchParams).value = $event : searchParams = $event)),
        isSearching: isSearching.value,
        onSearch: _cache[1] || (_cache[1] = ($event: any) => (getDeliveryPlans(makeParams())))
      }, null, 8, ["deliveryPlan", "modelValue", "isSearching"]),
      _createVNode(DeliveryPlanList, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
        deliveryPlans: deliveryPlans.value,
        page: page.value,
        totalPage: totalPage.value,
        onUpdatePage: updatePage
      }, null, 8, ["modelValue", "deliveryPlans", "page", "totalPage"])
    ]),
    _: 1
  }))
}
}

})